import { useEffect, useMemo, useReducer } from 'react';
import reducer, { initialState } from './reducer';
import useActions from './actions';
import useFetchFavourites from './useFetchFavourites';

/**
 * Returns the favourites state and actions to mutate the state
 * @returns {Object} {state, actions}
 */
const useFavourites = () => {
  const { favourites, loading } = useFetchFavourites();
  const [state, dispatch] = useReducer(reducer, initialState);
  const actions = useActions(dispatch);
  const value = useMemo(() => ({ state, actions, loading }), [state, loading]);

  useEffect(() => {
    if (favourites && favourites.length) {
      actions.setFavourites(favourites);
    }
  }, [loading]);

  return value;
};

export default useFavourites;
